var hasProp = window.hasProp;
var extend = window.extend;
var bind = window.bind;
var bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.UserSearch = function (superClass) {
  extend(UserSearch, superClass);
  function UserSearch() {
    this.formatResult = bind(this.formatResult, this);
    return UserSearch.__super__.constructor.apply(this, arguments);
  }
  UserSearch.prototype.resultTemplate = 'search/templates/user_result';
  UserSearch.prototype.initialize = function (options) {
    _.defaults(options, {
      tags: [],
      multiple: true,
      ajax: {
        url: "/users/search",
        data: function (_this) {
          return function (term) {
            return {
              q: term,
              hide_users: _this._hideUsers().join(','),
              include_contacts: options != null ? options.includeContacts : void 0,
              limit: options != null ? options.limit : void 0
            };
          };
        }(this),
        results: function (_this) {
          return function (data) {
            return {
              results: _.map((data != null ? data.results : void 0) || [], _this.parse, _this)
            };
          };
        }(this)
      }
    });
    return UserSearch.__super__.initialize.apply(this, arguments);
  };
  UserSearch.prototype._hideUsers = function () {
    return [$current_user.id];
  };
  UserSearch.prototype.formatSelection = function (userModel, container, escapeMarkup) {
    return escapeMarkup(userModel.get('name'));
  };
  UserSearch.prototype.formatResult = function (userModel, container, query, escapeMarkup) {
    return JST[this.resultTemplate]({
      user: userModel.toJSON()
    });
  };
  UserSearch.prototype.formatResultCssClass = function () {
    return 'select2-user-result bordered-search-result bootstrap';
  };
  UserSearch.prototype.parse = function (result) {
    var user;
    user = new Backbone.Model(result);
    if (!user.get('profile_pic_url')) {
      user.set('profile_pic_url', '/images/s65_no_pic.png');
    }
    if (user.get('id') && !user.get('university')) {
      user.set('university', 'Independent');
    }
    return user;
  };
  return UserSearch;
}(window.Search.Base);
window.bind = bind;
window.extend = extend;
window.hasProp = hasProp;